// Robust cross-browser download helper.
// Some mobile browsers and WebViews block downloads if the anchor element is
// not in the DOM at click time, or if the object URL is revoked too quickly.
export function downloadFile(data, filename, mime = "application/octet-stream") {
    const blob = data instanceof Blob ? data : new Blob([data], { type: mime });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
        try {
            document.body.removeChild(a);
        } catch {
            /* already removed */
        }
        URL.revokeObjectURL(url);
    }, 1000);
}
